import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./SlickSlider.scss"

export default function SlickSlider({sliderSettings, sliderClassName, children}) {
    const settings = sliderSettings;
    return (
        <div className={sliderClassName}>
            <Slider {...settings}>
                {children}
            </Slider>
        </div>
    );
}